import { Enum } from 'enumify';

export default class RoleType extends Enum {}
RoleType.initEnum([
  'DASHBOARD_READ_ONLY',
  'SUBSCRIPTION_READ_ONLY',
  'B2C_PRODUCT_LIST',
  'B2C_PRODUCT_LIST_READ_ONLY',
  'B2C_PATIENT_LIST',
  'B2C_PATIENT_LIST_READ_ONLY',
  'CLINICIAN_PATIENT_MAPPING',
  'CLINICIAN_PATIENT_MAPPING_READ_ONLY',
  'ASSET_CLINIC',
  'ASSET_CLINIC_READ_ONLY',
  'ASSET_CLINIC2',
  'ASSET_CLINIC2_READ_ONLY',
  'ASSET_HOME',
  'ASSET_HOME_READ_ONLY',
  'ASSET_COMCOG',
  'ASSET_COMCOG_READ_ONLY',
  'ASSET_COMCOG_ADMIN',
  'ASSET_COMCOG_ADMIN_READ_ONLY',
  'ASSET_COMCOG_PUBLIC',
  'ASSET_COMCOG_PUBLIC_READ_ONLY',
  'ASSET_SMART_COACH',
  'ASSET_SMART_COACH_READ_ONLY',
  'ASSET_SMART_CARE',
  'ASSET_SMART_CARE_READ_ONLY',
  'ASSET_SMART_TABLE',
  'ASSET_SMART_TABLE_READ_ONLY',
  'ASSET_B1',
  'ASSET_B1_READ_ONLY',
  'ASSET_B2',
  'ASSET_B2_READ_ONLY',
  'ASSET_SMART_BODY_CHECKER',
  'ASSET_SMART_BODY_CHECKER_READ_ONLY',
  'APK_CLINIC2',
  'APK_CLINIC2_READ_ONLY',
  'APK_HOME',
  'APK_HOME_READ_ONLY',
  'APK_COMCOG',
  'APK_COMCOG_READ_ONLY',
  'ADMIN_LIST',
  'ADMIN_LIST_READ_ONLY',
  'PERMISSIONS',
  'PERMISSIONS_READ_ONLY',
  'PERMISSION_GROUP',
  'PERMISSION_GROUP_READ_ONLY',
  'MULTILINGUAL_MGNT',
  'MULTILINGUAL_MGNT_READ_ONLY',
  'RELEASE_MGNT',
  'RELEASE_MGNT_READ_ONLY',
  'APK_CONTENTS',
  'APK_CONTENTS_READ_ONLY',
]);



// WEBPACK FOOTER //
// ./src/routes/RoleGroup/Roles/RoleType.js